<template>
  <div>
    <div class="row items-center q-col-gutter-x-md" v-if="!isAddingQuestion">
      <div class="title q-my-none q-mx-none">Questions</div>

      <div>
        <q-btn color="primary" @click="createQuestion">
          <q-icon name="mdi-plus-circle"> </q-icon>
          <span class="sustainability-font q-mx-sm" style="font-size: 13px">
            Add
          </span>
        </q-btn>
      </div>
    </div>
    <div class="row items-center justify-between full-width" v-else>
      <div class="row items-center">
        <div>
          <q-btn color="accent" @click="backFromForm" flat>
            <q-icon name="mdi-arrow-left"> </q-icon>
          </q-btn>
        </div>
        <div class="title q-my-none q-mx-none">Questions</div>
      </div>

      <div class="row justify-end">
        <q-btn color="primary" @click="saveQuestion(null)" class="float-right">
          <q-icon name="mdi-plus-circle"> </q-icon>
          <span class="sustainability-font q-mx-sm" style="font-size: 13px">
            Save
          </span>
        </q-btn>
      </div>
    </div>

    <div class="row q-mt-lg" v-if="!isAddingQuestion">
      <div class="col-12">
        <data-table
          style="height: calc(100vh - 280px)"
          flat
          :filter="search"
          :data="data"
          :columns="columns"
          headerBgColor="#162c47"
          headerTextColor="white"
          @rowDoubleClick="onQuestionDoubleClick"
        >
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                round
                color="red"
                flat
                icon="mdi-delete"
                @click="removeQuestion(data.props.row)"
                class="float-right"
              >
                <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                  Remove Question
                </q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </data-table>
      </div>
    </div>
    <div v-else>
      <q-form ref="form">
        <div class="row items-center q-col-gutter-x-md">
          <div class="col-4">
            <q-input
              v-model="formData.question"
              label="Question"
              :rules="[(v) => !!v || 'Field is Required']"
            >
            </q-input>
          </div>
          <div class="col-4">
            <q-select
              v-model="formData.action"
              :options="actionOptions"
              label="Action"
              :rules="[(v) => !!v || 'Field is Required']"
            >
            </q-select>
          </div>
          <div class="col-4">
            <q-select
              v-model="formData.selectionType"
              :options="selectionTypeOptions"
              label="Selection Type"
              :rules="[(v) => !!v || 'Field is Required']"
            >
            </q-select>
          </div>
          <div class="col-4">
            <q-input
              v-model="formData.idx"
              label="Rank"
              :rules="[
                (val) => !isNaN(parseFloat(val)) || 'Value must be a number',
              ]"
            >
            </q-input>
          </div>
          <div class="col-4">
            <q-checkbox
              label="Does it have a 'None of the above' field?"
              v-model="formData.hasNoneField"
              :rules="[(v) => !!v || 'Field is Required']"
              :true-value="1"
              :false-value="0"
            >
            </q-checkbox>
          </div>
        </div>
      </q-form>
      <div v-if="!isAddingOption">
        <div class="row items-center">
          <div class="title q-my-none q-mx-none q-mr-md">Options</div>

          <div>
            <q-btn color="primary" @click="createOptions">
              <q-icon name="mdi-plus-circle"> </q-icon>
              <span class="sustainability-font q-mx-sm" style="font-size: 13px">
                Add
              </span>
            </q-btn>
          </div>
        </div>
        <div class="row q-mt-md">
          <data-table
            style="height: calc(100vh - 450px)"
            flat
            :filter="search"
            :data="optionsData"
            :columns="optionsColumns"
            headerBgColor="#162c47"
            @rowDoubleClick="onOptionDoubleClick"
            headerTextColor="white"
          >
            <template slot="body-cell-actions" slot-scope="data">
              <q-td :props="data.props">
                <q-btn
                  round
                  color="red"
                  flat
                  icon="mdi-delete"
                  @click="removeOption(data.props.row)"
                  class="float-right"
                >
                  <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                    Remove Option
                  </q-tooltip>
                </q-btn>
              </q-td>
            </template>
          </data-table>
        </div>
      </div>

      <div v-else>
        <outcome-plan-question-option-form
          @backFromForm="backFromOptionForm"
        ></outcome-plan-question-option-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import DataTable from "@/components/datatable/datatable.vue";
  import OutcomePlanQuestionOptionForm from "@/components/outcomePlanQuestionTab/outcomePlanQuestionOptionForm/outcomePlanQuestionOptionForm.vue";
  export default {
    components: {
      DataTable,
      OutcomePlanQuestionOptionForm,
    },
    data: () => ({
      question: "",
      search: "",
      isAddingQuestion: false,
      isAddingOption: false,
      formData: {
        hasNoneField: 0,
      },
      actionOptions: ["Star", "Unstar"],
      selectionTypeOptions: ["Single", "Multiple"],
    }),
    mounted() {
      this.$store.dispatch(
        "outcomePlanQuestionnaire/loadAllByOutcomesID",
        this.$route.params.id
      );
      this.handleRoute();
    },
    watch: {
      $route: {
        handler() {
          this.handleRoute();
        },
        deep: true,
      },
    },
    computed: {
      ...mapGetters({
        data: "outcomePlanQuestionnaire/list",
        optionsData:
          "outcomePlanQuestionnaire/outcomePlanQuestionnaireOptions/list",
        outcomesList: "outcomes/list",
        selectedQuestion: "outcomePlanQuestionnaire/selectedOutcomePlanQuestion",
      }),
      optionsColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "rank",
            label: "Rank",
            align: "left",
            field: "idx",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "option",
            label: "Option",
            align: "left",
            field: "text",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "type",
            label: "Type",
            align: "left",
            field: "type",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "createdAt",
            label: "Created At",
            align: "left",
            field: "created_at",
            format: (val) => {
              return this.$options.filters.gridDateFormat(val);
            },
          },
          {
            name: "actions",
            label: "Actions",
            align: "left",
            style:
              "min-width:30px;max-width:30px;width:30px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
        ];
      },
      columns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "rank",
            label: "Rank",
            align: "left",
            field: "idx",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "question",
            label: "Question",
            align: "left",
            field: "question",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "action",
            label: "Action",
            align: "left",
            field: "action",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "selectionType",
            label: "Selection Type",
            align: "left",
            field: "selectionType",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "hasNoneField",
            label: "Has a None Field",
            align: "left",
            field: "hasNoneField",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
            format: (val) => {
              if (parseFloat(val) == 1) {
                return "Yes";
              } else {
                return "";
              }
            },
          },
          {
            name: "createdAt",
            label: "Created At",
            align: "left",
            field: "created_at",
            format: (val) => {
              return this.$options.filters.gridDateFormat(val);
            },
          },
          {
            name: "actions",
            label: "Actions",
            align: "left",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
        ];
      },
    },
    methods: {
      handleRoute() {
        if (
          this.$route.params.hasOwnProperty("outcomePlanQuestionnaireOptions_id")
        ) {
          this.initQuestionForm();
          this.isAddingQuestion = true;
          this.isAddingOption = true;
          this.$store.dispatch(
            "outcomePlanQuestionnaire/outcomePlanQuestionnaireOptions/loadAllByQuestionnaireID",
            this.$route.params.outcomePlanQuestionnaireOptions_id
          );
        } else if (
          this.$route.params.hasOwnProperty("outcomePlanQuestionnaire_id")
        ) {
          this.$store.dispatch(
            "outcomePlanQuestionnaire/outcomePlanQuestionnaireOptions/loadAllByQuestionnaireID",
            this.$route.params.outcomePlanQuestionnaire_id
          );
          this.initQuestionForm();
          this.isAddingQuestion = true;
          this.isAddingOption = false;
        }
      },
      onQuestionDoubleClick(row) {
        this.$router.push(this.$route.path + "/questions/" + row.id);
      },
      onOptionDoubleClick(row) {
        this.$router.push(this.$route.path + "/options/" + row.id);
      },
      async createOptions() {
        let result = await this.$store.dispatch(
          "outcomePlanQuestionnaire/outcomePlanQuestionnaireOptions/new",
          {
            status: "temp",
            outcomePlanQuestionnaire_id:
              this.$route.params.outcomePlanQuestionnaire_id,
          }
        );

        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          this.$router.push(this.$route.path + "/options/" + result.Response.id);
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
      initQuestionForm() {
        this.$store
          .dispatch(
            "outcomePlanQuestionnaire/loadByID",
            this.$route.params.outcomePlanQuestionnaire_id
          )
          .then(() => {
            if (this.selectedQuestion) {
              this.formData = JSON.parse(JSON.stringify(this.selectedQuestion));
            }
          });
      },
      backFromForm() {
        if (this.$route.params.hasOwnProperty("outcomePlanQuestionnaire_id")) {
          this.$router.push("/outcomes/" + this.$route.params.id);
          this.isAddingQuestion = false;
        }
      },
      backFromOptionForm() {
        if (
          this.$route.params.hasOwnProperty("outcomePlanQuestionnaireOptions_id")
        ) {
          this.$router.push(
            "/outcomes/" +
              this.$route.params.id +
              "/questions/" +
              this.$route.params.outcomePlanQuestionnaire_id
          );
          this.isAddingOption = false;
        }
      },
      async removeOption(row) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let payload = {
              ...row,
            };
            payload.deleted_at = true;
            this.saveOption(payload);
          }
        });
      },
      async saveOption(deletedPayload) {
        let isValid = null;
        if (deletedPayload) {
          isValid = true;
        } else {
          isValid = await this.$refs.form.validate();
        }

        if (isValid) {
          let payload = null;
          if (deletedPayload) {
            payload = deletedPayload;
          } else {
            payload = JSON.parse(JSON.stringify(this.formData));
            payload["values"] = JSON.stringify(this.formData.values);
            payload["status"] = "live";
          }
          let result = await this.$store.dispatch(
            "outcomePlanQuestionnaire/outcomePlanQuestionnaireOptions/save",
            payload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.backFromOptionForm();
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async removeQuestion(row) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let payload = {
              ...row,
            };
            payload.deleted_at = true;
            this.saveQuestion(payload);
          }
        });
      },
      async saveQuestion(deletedPayload) {
        let isValid = null;
        if (deletedPayload) {
          isValid = true;
        } else {
          isValid = await this.$refs.form.validate();
        }
        if (isValid) {
          let payload = null;
          if (deletedPayload) {
            payload = deletedPayload;
          } else {
            payload = this.formData;
            payload["status"] = "live";
          }

          let result = await this.$store.dispatch(
            "outcomePlanQuestionnaire/save",
            payload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async createQuestion() {
        let result = await this.$store.dispatch("outcomePlanQuestionnaire/new", {
          status: "temp",
          outcomes_id: this.$route.params.id,
        });

        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          this.$router.push(
            this.$route.path + "/questions/" + result.Response.id
          );
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 13px;
  }
</style>
